/**
 * Utilidad para generar y gestionar Device ID único
 * Se guarda en localStorage del navegador
 */

export const getDeviceId = () => {
  const STORAGE_KEY = 'device_id_asistencia';
  
  // Intentar obtener Device ID existente
  let deviceId = localStorage.getItem(STORAGE_KEY);
  
  if (!deviceId) {
    // Generar nuevo Device ID
    deviceId = generateDeviceId();
    localStorage.setItem(STORAGE_KEY, deviceId);
  }
  
  return deviceId;
};

const generateDeviceId = () => {
  // Combinar varios factores para ID único
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 15);
  const random2 = Math.random().toString(36).substring(2, 15);
  
  // Información del navegador/dispositivo
  const screenInfo = `${window.screen.width}x${window.screen.height}`;
  const navigatorInfo = navigator.userAgent;
  
  // Crear hash simple (no necesita ser criptográfico)
  const combined = `${timestamp}-${random}${random2}-${screenInfo}-${navigatorInfo}`;
  
  // Generar ID base64-like
  return btoa(combined)
    .replace(/[^a-zA-Z0-9]/g, '')
    .substring(0, 32);
};

export const getUserAgent = () => {
  return navigator.userAgent || 'unknown';
};

export const getScreenResolution = () => {
  return `${window.screen.width}x${window.screen.height}`;
};
